<div class="wrapper-notification">
  <div class="section-title row">
    <div class="section-btn">
      <button
        routerLink="/dashboard/overview"
        class="btn btn-back" [attr.aria-label]="'Back' | translate">
        <i class="fi-rr-arrow-alt-left"></i>
      </button>
    </div>
    <div>
      <div class="title" [attr.data-parent]="'Dashboard' | translate">Notification</div>
    </div>
  </div>

  <div class="section-main">
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <tbody>
              <tr *ngIf="notificationList.length == 0 && !loading">
                <td
                  colspan="8"
                  class="border-left-0 border-right-0 pb-4 text-center no-records"
                >
                  No notifications found
                </td>
              </tr>
              <tr *ngIf="loading">
                <td
                  class="border-left-0 border-right-0 pb-4 text-center"
                  colspan="8"
                >
                  <div class="loading-spinner col-12">
                    <mat-spinner
                      class="mx-auto my-3"
                      [diameter]="50"
                    ></mat-spinner>
                  </div>
                </td>
              </tr>
              <tr *ngIf="notificationArray.length != 0">
                <td>
                  <input type="checkbox" (change)="checkUncheckAll($event)" />
                </td>
                <td>
                  <button
                    *ngIf="showReadButton"
                    class="btn btn-blue-small"
                    (click)="onSave()"
                  >
                    Mark as read
                  </button>
                </td>
              </tr>
              <tr
                *ngFor="let item of notificationList; let index = index"
                (click)="collapseToggle(notificationData[index]['id'])"
              >
                <div
                  *ngIf="
                    readChecking;
                    then unreadNotification;
                    else readNotification
                  "
                ></div>
                <ng-template #unreadNotification
                  ><td>
                    <input
                      type="checkbox"
                      [checked]="isChecks"
                      value="{{ notificationData[index]['id'] }}"
                      (change)="
                        onClickCheck($event, notificationData[index]['id'])
                      "
                    /></td
                ></ng-template>
                <ng-template #readNotification
                  ><td><input type="checkbox" disabled /></td
                ></ng-template>
                <td>
                  <div class="notification-title">
                    {{ item["notification_content"]["en-US"]["title"] }}
                  </div>
                  <div
                    [@collapse]="!visible[notificationData[index]['id']]"
                    class="notification-disc"
                  >
                    {{ item["notification_content"]["en-US"]["body"] }}
                  </div>
                </td>
                <td>
                  <div>{{ item["create_at"] }}</div>
                </td>
                <td>
                  <div
                    class="showtext-display"
                    *ngIf="!showTab[notificationData[index]['id']]"
                  >
                    <i class="fi fi-rr-angle-small-up"></i>
                  </div>
                  <div
                    class="showtext-display"
                    *ngIf="showTab[notificationData[index]['id']]"
                  >
                    <i class="fi fi-rr-angle-small-down"></i>
                  </div>
                </td>
                <!-- <td><a href="#"><i class="fi fi-rr-envelope-open"></i></a></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="notificationList.length != 0 && !loading"
    class="row px-4 py-3 pagination"
  >
    <div class="col-md-12 col-lg-4">
      <ngb-pagination
        [collectionSize]="notificationArray.length"
        [(page)]="page"
        [pageSize]="selectedPage"
        aria-label="Default pagination"
        (pageChange)="changePage($event)"
      ></ngb-pagination>
    </div>
    <div class="col-md-12 col-lg-4 lg-center">
      <div class="mt-2 text-center">
        {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
        <b>{{ notificationArray.length }}</b>
      </div>
    </div>
  </div>
</div>
